export const createErrorAction = (type: string) => (error, params) => ({
    type,
    payload: {error, ...params}
});
